/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableOpacity, ScrollView } from 'react-native'
import styles from './Styles/CaptionOverlayComponentStyle'
import { SvgClose } from './SvgComponent/';
import TextComponent from './TextComponent'
import { convertMessage } from '../Lib/utils'
export default class CaptionOverlayComponent extends Component {

  capitalizeFirstLetter = (string) => {
  //   <View style={styles.captionView}>
  //   {convertMessage({
  //     item: post.caption,
  //     navigation
  //   }, () => {
  //         onPress()
  //     })}
  // </View>
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  render() {
    const { post, onPress, containerStyle, navigation } = this.props
    return (
      <View
        style={containerStyle}>
        <TouchableOpacity style={styles.closeButton} onPress={onPress}>
          <SvgClose size="20" />
        </TouchableOpacity>
        <ScrollView style={styles.scrollview}>
        {post.comments && post.comments.map( (comment, index)   =>{
          return (
            <View   key={`c` + index} style={{ flexDirection: `row`,
            backgroundColor: comment.bgColor , flexWrap: 'wrap', flexGrow : 1
           }} numberOfLines={comment.NumLines}>
              <TextComponent style={{

                fontSize: 14,
                lineHeight: 20,
                fontWeight: 'bold',
                color: '#4f5271',

                backgroundColor: comment.bgColor

              }} text= {comment.Username} />

              <View style = {{paddingLeft: 10}}>
              {convertMessage({
                item: comment.Body,
                styles: {},
                navigation
              }, () => {
                onPress()
                })}
              </View>


            </View>
          )
        })}

        </ScrollView>
      </View>
    )
  }
}
